import { Accordion, AccordionDetails, AccordionSummary, Chip, Input, Paper, Stack, Typography } from '@mui/material';
import { variants } from '../../../../variants/variants';
import { Check, Clear, Timer, ExpandMore } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { selectCurrent, selectFullScreen, selectMessages, selectViewPrefilledForm } from '../../giftSlice';
import { useEffect, useRef, useState } from 'react';
import { hourglass, empty } from '../../assets/index';
const RenderPreview = ({ completed = {}, kras, label }) => {
  const showPending = Boolean(Object.keys(completed).length === 0);
  const fullScreen = useSelector(selectFullScreen);
  const viewForm = useSelector(selectViewPrefilledForm);
  const [expanded, setExpanded] = useState('');
  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.lastElementChild?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest',
    });
  };
  const current = useSelector(selectCurrent);
  const messages = useSelector(selectMessages);
  useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
    }, 0);
  }, [messages, current.question]);
  return (
    <Stack alignItems={'center'}>
      {fullScreen && (
        <Chip
          label={label}
          sx={{
            background: '#0A4FAC',
            color: 'white',
            fontWeight: 600,
          }}
        />
      )}
      {showPending
        ? !fullScreen && (
            <Stack alignItems={'center'} sx={{ p: 2, mt: 2 }}>
              <img style={{ width: '50%' }} src={empty} alt='pending' />
              <Typography sx={{ fontSize: variants.TINY, p: 1, color: 'rgba(0,0,0,0.7)' }}>
                No details filled!
              </Typography>
            </Stack>
          )
        : Object.keys(completed).map((title, index) => {
            const questions = kras?.find(obj => obj.title === title);
            let kraCompleted = viewForm ? true : questions.questions.length === completed[title].length;
            let currentActive = !kraCompleted || expanded === title;
            return (
              <Accordion
                className={!kraCompleted ? 'alerts-border' : 'none'}
                expanded={currentActive}
                onChange={handleChange(title)}
                elevation={0}
                key={index}
                sx={{ mt: 1, background: '#f4f6f8', width: 1 }}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography sx={{ fontSize: variants.BODY, display: 'flex', alignItems: 'center' }}>
                    {title}
                    {kraCompleted ? (
                      <Check fontSize='small' sx={{ ml: 1, color: 'green' }} />
                    ) : (
                      <img src={hourglass} style={{ width: 25, height: 25, mixBlendMode: 'multiply' }} />
                      // <Timer fontSize='small' sx={{ ml: 1, color: variants.color.pending }} />
                    )}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails ref={messagesEndRef}>
                  {completed[title]?.map((question, index) => {
                    return (
                      <Paper
                        elevation={1}
                        key={index}
                        sx={{
                          p: 1,
                          mt: 1,
                          background:
                            question?.answer === 'yes'
                              ? variants.color.successBackground
                              : variants.color.errorBackground,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: variants.BODY,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {question?.answer === 'yes' ? (
                            <Check fontSize='small' sx={{ mr: 1, color: 'green' }} />
                          ) : (
                            <Clear fontSize='small' sx={{ mr: 1, color: 'red' }} />
                          )}
                          {question?.question}
                        </Typography>

                        {question?.answer === 'yes' && (
                          <Input
                            fullWidth
                            disableUnderline
                            multiline
                            size='small'
                            value={question?.reason}
                            sx={{
                              border: 1,
                              borderRadius: '7px',
                              borderColor: 'divider',
                              p: 0.5,
                              textarea: { fontSize: variants.TINY },
                              mt: 1,
                              caretColor: 'transparent',
                              '> :hover': {
                                cursor: 'default',
                              },
                            }}
                          />
                        )}
                      </Paper>
                    );
                  })}
                  <div style={{ padding: '0.25rem' }} />
                </AccordionDetails>
              </Accordion>
            );
          })}
    </Stack>
  );
};

export default RenderPreview;
